export default __webpack_public_path__ + "static/media/interior_01_01_big.22b84965.jpg";